<template>
  <page>
    <lazy-div>
      <v-card>
        <v-toolbar dense color="grey lighten-3" flat>
          <v-icon v-if="tranMode === 'New'">mdi-plus</v-icon>
          <v-icon v-if="tranMode === 'Review'">mdi-pencil</v-icon>
          <v-icon v-if="tranMode === 'Query'">mdi-magnify</v-icon>
          <v-toolbar-title v-if="tranMode === 'New'">Create Document Heading Text</v-toolbar-title>
          <v-toolbar-title v-if="tranMode === 'Review'">Edit Document Heading Text</v-toolbar-title>
          <v-toolbar-title v-if="tranMode === 'Query'">View Document Heading Text</v-toolbar-title>
        </v-toolbar>
        <v-card-text>
          <message :messages="messages"></message>
          <v-container fluid grid-list-lg>
            <v-layout row wrap>
              <v-flex md6 v-if="tranMode === 'New'">
                <v-autocomplete
                  :label="labels.docNo"
                  :items="docNoList"
                  v-model="form.docNo"
                  item-text="codeValue"
                  item-value="code"
                  data-vv-name="docNo"
                  :data-vv-as="labels.docNo"
                  :error-messages="errors.collect('docNo')"
                  v-validate="'required'"
                  @change="onChange()"
                ></v-autocomplete>
              </v-flex>
              <v-flex md6 v-else>
                <v-subheader class="queryLabel">{{ labels.docNo }}</v-subheader>
                <div class="queryValue" v-for="item in filterDocNoList" :key="item.label">{{ item.code }} - {{ item.value }}</div>
              </v-flex>
              <!-- OK-480: Added to keep track the docNo -->
              <v-flex md6 v-if="tranMode === 'Review'" v-show="false">
                <v-autocomplete
                  readonly
                  :label="labels.docNo"
                  :items="docNoList"
                  v-model="form.docNo"
                  item-text="codeValue"
                  item-value="code"
                  data-vv-name="docNo"
                  :data-vv-as="labels.docNo"
                  :error-messages="errors.collect('docNo')"
                  v-validate="'required'"
                  @getValue="getValue(form.docNo)"
                ></v-autocomplete>
              </v-flex>
              <v-flex md6 v-if="tranMode === 'New'">
                <v-text-field
                  v-model="form.docHdgNo"
                  :label="labels.docHdgNo"
                  :error-messages="errors.collect('docHdgNo')"
                  data-vv-name="docHdgNo"
                  :data-vv-as="labels.docHdgNo"
                  v-validate="'required|max:8|mask_decimal:0|mask_min_value:0'"
                ></v-text-field>
              </v-flex>
              <v-flex md6 v-else>
                <v-subheader class="queryLabel">{{ labels.docHdgNo }}</v-subheader>
                <div class="queryValue">{{ form.docHdgNo }}</div>
              </v-flex>
            </v-layout>
            <v-layout row wrap>
              <v-flex md6 v-if="tranMode === 'New'">
                <v-autocomplete
                  :label="labels.polType"
                  :items="polTypeList"
                  v-model="form.polType"
                  item-text="value"
                  item-value="code"
                  data-vv-name="polType"
                  :data-vv-as="labels.polType"
                  :error-messages="errors.collect('polType')"
                  v-validate="''"
                ></v-autocomplete>
              </v-flex>
              <v-flex md6 v-else>
                <v-subheader class="queryLabel">{{ labels.polType }}</v-subheader>
                <div class="queryValue" v-for="item in filterPolTypeList" :key="item.label">{{ item.value }}</div>
              </v-flex>
            </v-layout>
            <v-layout
              row
              wrap
              v-if="
                form.docNo === '620' ||
                form.docNo === '622' ||
                form.docNo === '623' ||
                form.docNo === '624' ||
                form.docNo === '625' ||
                form.docNo === '626' ||
                form.docNo === '627' ||
                form.docNo === '628'
              "
            >
              <v-flex md12>
                <v-textarea
                  id="inputTextField"
                  v-shortkey="{ curbr: ['shift', '{'] }"
                  @shortkey.native="toggleTagList"
                  v-model="form.hdgText"
                  :label="labels.hdgText"
                  data-vv-name="hdgText"
                  :data-vv-as="labels.hdgText"
                  v-validate="''"
                  auto-grow
                  rows="3"
                  row-height="25"
                  @focusout="focusout"
                  :readonly="tranMode === 'Query'"
                ></v-textarea>
              </v-flex>
              <v-flex md12>
                <div v-show="show" class="options popover" ref="optionsList">
                  <ul>
                    <li
                      v-for="(item, index) in tagsList"
                      :key="index"
                      :class="{ selected: selected === index }"
                      @click="itemClicked(index)"
                      v-text="item.value"
                    ></li>
                  </ul>
                </div>
              </v-flex>
            </v-layout>
            <v-layout row wrap v-else>
              <v-flex md12>
                <v-textarea
                  v-model="form.hdgText"
                  :label="labels.hdgText"
                  data-vv-name="hdgText"
                  :data-vv-as="labels.hdgText"
                  v-validate="''"
                  auto-grow
                  rows="3"
                  row-height="25"
                  :readonly="tranMode === 'Query'"
                ></v-textarea>
              </v-flex>
            </v-layout>
          </v-container>
          <v-container md6 fluid grid-list-lg>
            <v-layout>
              <v-flex xs6>
                <v-subheader class="queryLabel">{{ labels.createdBy }}</v-subheader>
                <div class="queryValue">{{ createdBy }}</div>
              </v-flex>
              <v-flex xs6>
                <v-subheader class="queryLabel">{{ labels.createdDate }}</v-subheader>
                <div class="queryValue">{{ formatDisplayDate(createdDate) }}</div>
              </v-flex>
            </v-layout>
            <v-layout v-if="tranMode !== 'New'">
              <v-flex xs6>
                <v-subheader class="queryLabel">{{ labels.modifiedBy }}</v-subheader>
                <div class="queryValue">{{ modifiedBy }}</div>
              </v-flex>
              <v-flex xs6>
                <v-subheader class="queryLabel">{{ labels.modifiedDate }}</v-subheader>
                <div class="queryValue">{{ formatDisplayDate(modifiedDate) }}</div>
              </v-flex>
            </v-layout>
          </v-container>
          <v-container fluid grid-list-lg>
            <v-btn color="error" dark class="mr-2" @click.prevent="doCancel">Cancel<v-icon dark right>mdi-cancel</v-icon></v-btn>
            <v-btn v-if="tranMode !== 'Query'" color="primary" dark class="mr-2" @click="doSave" :loading="submitting">
              Save
              <v-icon right>mdi-content-save</v-icon>
            </v-btn>
          </v-container>
        </v-card-text>
      </v-card>
    </lazy-div>
  </page>
</template>

<script>
import MessageMixin from '@/mixins/message'
import { formatDisplayDate } from '@/utils/date'
import { expandURI } from '@/utils/ajax'
import { tagsList, tagsList1, tagsList2, docNoList } from './index'

export default {
  props: {
    shouldReset: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      show: false,
      clickedChooseItem: false,
      selectedItem: null,
      selected: 0,
      labels: {
        docNo: 'Document',
        docHdgNo: 'Heading No.',
        polType: 'Policy Type',
        hdgText: 'Document Heading Text',
        createdBy: 'Created By',
        createdDate: 'Created Date',
        modifiedBy: 'Modified By',
        modifiedDate: 'Modified Date'
      },
      form: {
        docNo: '',
        docHdgNo: '',
        polType: '',
        hdgText: ''
      },
      createdBy: this.$store.state.token.firstName + ' ' + this.$store.state.token.lastName,
      createdDate: new Date(),
      modifiedBy: '',
      modifiedDate: undefined,
      docNoList: [],
      polTypeList: [],
      tagsList: [],
      newMode: false,
      reviewMode: false,
      loading: false,
      submitting: false
    }
  },
  methods: {
    formatDisplayDate(xDate) {
      return formatDisplayDate(xDate)
    },
    toggleTagList(event) {
      if (event.srcKey === 'curbr') {
        this.show = !this.show
      }
    },
    itemClicked(index) {
      this.selected = index
      this.selectItem()
    },
    selectItem() {
      let cursorIndex = document.getElementById('inputTextField').selectionEnd
      this.clickedChooseItem = true
      if (!this.tagsList.length) {
        return
      }
      this.selectedItem = this.tagsList[this.selected]
      if (this.shouldReset) {
        this.selected = 0
      }
      this.$emit('selected', JSON.parse(JSON.stringify(this.selectedItem)))
      // this.form.hdgText. += this.selectedItem.value
      this.form.hdgText = this.form.hdgText.substring(0, cursorIndex) + this.selectedItem.value + this.form.hdgText.substring(cursorIndex)
      this.show = false
    },
    focusout(e) {
      setTimeout(() => {
        if (!this.clickedChooseItem) {
          this.show = false
        }
        this.clickedChooseItem = false
      }, 100)
    },
    scrollToItem() {
      this.$refs.optionsList.scrollTop = this.selected * this.itemHeight
    },
    async doFetchData() {
      const apiURI = this.menu.getDocHdgTxt
      if (apiURI) {
        this.loading = true
        const expand = { docNo: this.docNoParam, polType: this.polTypeParam, docHdgNo: this.docHdgNoParam }
        this.$http
          .get(expandURI(apiURI, expand))
          .then((result) => {
            const { data } = result.data
            if (data) {
              this.form.docNo = data.docHdgTxt.docNo
              this.form.docHdgNo = data.docHdgTxt.docHdgNo
              this.form.polType = data.docHdgTxt.polType
              this.form.hdgText = data.docHdgTxt.hdgText
              this.createdBy = data.createdBy
              this.createdDate = data.createdDate
              this.modifiedBy = data.modifiedBy
              this.modifiedDate = data.modifiedDate
            }
            this.loading = false
          })
          .catch((err) => {
            this.loading = false
            const { data } = err.response
            if (data) {
              this.message(data)
              this.fieldMessage(data)
            }
          })
      }
    },
    async doFetchPolType() {
      const apiURI = this.menu.getPolTypeAndDesc
      if (apiURI) {
        try {
          this.loading = true
          const result = await this.$http.get(apiURI)
          const { data } = result.data
          this.items = []
          if (data) {
            data.map((datamap) => {
              const convertList = {
                code: datamap.polTypeAll,
                value: datamap.polTypeAll + ' - ' + datamap.polTypeDescAll
              }
              this.items.push(convertList)
              this.polTypeList = this.items
            })
          }
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
        }
        this.loading = false
      }
    },
    doSave() {
      this.resetMessages()
      this.$validator.validateAll().then((result) => {
        if (result) {
          if (this.newMode) {
            this.doCreate()
          } else {
            this.doUpdate()
          }
        } else {
          this.promptFieldCheck()
        }
      })
    },
    async doCreate() {
      const apiURI = this.menu.createDocHdgTxt
      const form = this.form
      if (apiURI) {
        this.submitting = true
        try {
          if (form.polType === undefined) {
            form.polType = ''
          }
          const result = await this.$http.post(apiURI, form)
          const { data } = result
          if (data) {
            this.notify(data)
            this.message(data)
            this.fieldMessage(data)
            this.doCancel()
          }
          this.submitting = false
        } catch (err) {
          this.submitting = false
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
        }
      }
    },
    async doUpdate() {
      const apiURI = this.menu.updateDocHdgTxt
      const form = this.form
      if (apiURI) {
        if (form.polType === undefined) {
          form.polType = ''
        }
        this.submitting = true
        try {
          const result = await this.$http.put(apiURI, form)
          const { data } = result
          if (data) {
            this.notify(data)
            // to go back to the list
            this.doCancel()
          }
          this.submitting = false
        } catch (err) {
          this.submitting = false
          const { data } = err.response.data
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
        }
      }
    },
    doCancel() {
      this.$router.push({ name: 'docHdgTxtList' })
    },
    onChange() {
      this.tagsList = []
      if (
        this.form.docNo === '620' ||
        this.form.docNo === '622' ||
        this.form.docNo === '626' ||
        this.form.docNo === '627' ||
        this.form.docNo === '628'
      ) {
        this.tagsList = tagsList
      } else if (this.form.docNo === '623') {
        this.tagsList = tagsList.concat(tagsList1)
      } else if (this.form.docNo === '624' || this.form.docNo === '625') {
        this.tagsList = tagsList.concat(tagsList2)
      } else {
        this.tagsList = []
      }
      this.show = false
    },
    getValue(value) {
      this.tagsList = []
      if (
        this.form.docNo === '620' ||
        this.form.docNo === '622' ||
        this.form.docNo === '626' ||
        this.form.docNo === '627' ||
        this.form.docNo === '628'
      ) {
        this.tagsList = tagsList
      } else if (this.form.docNo === '623') {
        this.tagsList = tagsList.concat(tagsList1)
      } else if (this.form.docNo === '624' || this.form.docNo === '625') {
        this.tagsList = tagsList.concat(tagsList2)
      } else {
        this.tagsList = []
      }
      this.show = false
    }
  },
  computed: {
    menu() {
      return this.$store.state.docHdgTxtParam.menu
    },
    docNoParam() {
      const docNo = this.$route.params.docNo
      if (docNo === 'null') {
        return 'nullReturned'
      }
      return docNo
    },
    docHdgNoParam() {
      const docHdgNo = this.$route.params.docHdgNo
      if (docHdgNo === 'null') {
        return 'nullReturned'
      }
      return docHdgNo
    },
    polTypeParam() {
      const polType = this.$route.params.polType
      if (polType === 'null') {
        return 'nullReturned'
      }
      return polType
    },
    tranMode() {
      return this.$route.params.tranMode
    },
    filterDocNoList() {
      return this.docNoList.filter((list) => {
        return list.code === this.docNoParam
      })
    },
    filterPolTypeList() {
      return this.polTypeList.filter((list) => {
        return list.code === this.polTypeParam
      })
    }
  },
  created() {
    this.doFetchPolType()
    if (this.docNoParam === 'new' && this.polTypeParam === 'new' && this.docHdgNoParam === 'new') {
      this.newMode = true
    } else if (this.docNoParam.length > 0 || this.polTypeParam.length > 0 || this.docHdgNoParam.length > 0) {
      this.reviewMode = true
      this.form.docNo = this.docNoParam
      this.onChange()
      this.doFetchData()
    }
    this.docNoList = docNoList
  },
  mixins: [MessageMixin]
}
</script>

<style lang="scss">
.options {
  max-height: 200px;
  min-width: 580px;
  overflow-y: scroll;
  margin-top: 5px;
}
.options ul {
  list-style-type: none;
  text-align: left;
  padding-left: 0;
}
.options ul li {
  font-size: 16px;
  font-weight: 400;
  padding: 10px;
  cursor: pointer;
  background: white;
}
.options ul li:hover {
  background: #f5f5f5;
}
.popover {
  box-shadow: 0 5px 5px -3px rgba(0, 0, 0, 0.2), 0 8px 10px 1px rgba(0, 0, 0, 0.14), 0 3px 14px 2px rgba(0, 0, 0, 0.12);
  border: 2px solid lightgray;
  background-color: white;
  text-align: center;
  border-radius: 3px;
  padding: 5px 0;
  position: relative;
  z-index: 1;
  // display: inline-block;
  top: -15%;
}
</style>
